export const LAND_PURPOSE_LABELS = {
  residential: "Під житлову забудову",
  agricultural: "Сільськогосподарське",
  commercial: "Комерційне використання",
  industrial: "Промислове використання",
  recreational: "Рекреаційне",
  garden: "Сад / котедж",
};

export const COMMERCIAL_SUITABILITY_LABELS = {
  office: "Офіс",
  retail: "Торгівля",
  warehouse: "Склад",
  restaurant: "Ресторан / кафе",
  hotel: "Готель",
  production: "Виробництво",
  mixed: "Змішане використання",
};

export const WALL_LABELS = {
  brick: "Цегла",
  blocks: "Блоки",
  monolith: "Моноліт",
  panel: "Панель",
  wood: "Дерево",
  other: "Інше",
};

export const HEATING_LABELS = {
  central: "Центральне",
  gas: "Індивідуальне (газове)",
  electric: "Індивідуальне (електричне)",
  stove: "Індивідуальне (пічне)",
  solar: "Індивідуальне (сонячні батареї)",
  solid: "Індивідуальне (твердопаливне)",
  roof_boiler: "Дахова котельня",
  other: "Інше",
};

export const CONDITION_LABELS = {
  none: "Без ремонту",
  raw: "Сирець",
  needs_repair: "Потребує ремонту",
  cosmetic: "Косметичний ремонт",
  euro: "Євроремонт",
  designer: "Дизайнерський ремонт",
};

export const FURNITURE_LABELS = {
  full: "Є все необхідне",
  partial: "Частково",
  none: "Немає",
};

export const FACT_FIELD_LABELS = {
  total_area_m2: "Загальна площа",
  living_area_m2: "Житлова площа",
  kitchen_area_m2: "Кухня",
  rooms: "Кімнати",
  bathrooms: "Санвузли",
  floor: "Поверх",
  total_floors: "Поверхів",
  year_built: "Рік",
  land_area_m2: "Ділянка",
  walls: "Стіни",
  heating: "Опалення",
  condition: "Стан",
  furniture: "Меблі",
  residential_complex: "ЖК",
  has_balcony: "Балкон",
  has_parking: "Парковка",
  area_m2: "Площа",
  purpose: "Призначення",
  has_road_access: "Під'їзд",
  has_utilities: "Комунікації",
  suitable_for: "Підходить для",
};

const ENUM_LABELS_BY_KEY = {
  walls: WALL_LABELS,
  heating: HEATING_LABELS,
  condition: CONDITION_LABELS,
  furniture: FURNITURE_LABELS,
  purpose: LAND_PURPOSE_LABELS,
  suitable_for: COMMERCIAL_SUITABILITY_LABELS,
};

const AREA_KEYS = new Set([
  "total_area_m2",
  "living_area_m2",
  "kitchen_area_m2",
  "land_area_m2",
  "area_m2",
]);

export function booleanLabel(value) {
  if (value === true) return "Так";
  if (value === false) return "Ні";
  return null;
}

export const UNKNOWN_ENUM_LABEL = "Інше";

export function enumLabel(labels, value) {
  if (value === null || value === undefined || value === "") return null;
  if (labels && Object.prototype.hasOwnProperty.call(labels, value)) {
    return labels[value];
  }
  return UNKNOWN_ENUM_LABEL;
}

export function formatFactValue(key, value, facts = null) {
  if (value === null || value === undefined || value === "") return null;
  if (typeof value === "boolean") return booleanLabel(value);
  const enumMap = ENUM_LABELS_BY_KEY[key];
  if (enumMap) return enumLabel(enumMap, value);
  if (AREA_KEYS.has(key)) return `${value} м²`;
  if (key === "floor" && facts && facts.total_floors) {
    return `${value} із ${facts.total_floors}`;
  }
  return String(value);
}

export function factFieldLabel(key) {
  return FACT_FIELD_LABELS[key] || null;
}
